//Note that if an ad unit is named anything but these, it will default to a 1x1.

var sizes = {
    'leaderc':[[1,1],[728,90]],
    'spot':[[1,1],[300,90]],
    'mrect':[[1,1],[300,250]],
    'mab':[[1,1],[300,50],[320,50]],
    'mbanner':[[1,1],[300,50],[320,50]],
    'billboard':[[1,1],[1152,516],[970,250],[728,315]],
    'mspot':[[1,1],[300,90]],
    'easlisting':[[2,1]],
    'easlisting_chal':[[2,1]],
    'btheader':[[1,1],[220,48]],
    'mbtheader':[[1,1],[220,48]],
    'deeplink': [[1,1],[320,52]],
    'mdeeplink': [[1,1],[320,52]],
    'nav': [[1,1],[342,56]],
    'snav': [[1,1],[277,55]],
    'sponvidnative': ['fluid'],
    'sponsoredvideo': [[250,32]],
    'msponsoredvideo': [[250,32]],
    'insurestimatetab': [[1,1],[344,256]],
    'minsurestimatetab': [[1,1],[267,105]],
    'default':[[1,1]]
};

function getSize(unit) {
    return sizes[unit] || sizes['default'];
}
module.exports = {
    getSize: getSize
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-tags/ad-sizes.js
// module id = 446
// module chunks = 36